export default "__VITE_ASSET__Bk2lpKsq__"